import React, { useState } from "react";
import classes from './TipoAlertas.module.css';
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Grid, IconButton, Tooltip, Typography } from "@mui/material";
import TipoAlertasCard from "./TipoAlertasCard";

const TipoAlertasCategoriaCard = (props) => {
  const { categoria, alertas, index } = props;
  const [openAlertas, setOpenAlertas] = useState(false);

  return (
    <Grid item xs={12} container spacing={1} 
      className={classes.ItemCard} sx={{ marginInline: '8px' }}
      direction='row' justifyContent='space-between' alignContent='center'>
      <Grid item xs={11}>
        <Typography variant="h6">
          <strong>{categoria && categoria !== '' ? categoria : `Categoría ${index + 1}`}</strong>
        </Typography>
      </Grid>
      <Grid item xs={1} sx={{ textAlign: 'end' }}>
        <Tooltip title={openAlertas ? 'Colapsar alertas' : 'Expandir alertas'}>
          <IconButton size='large' onClick={() => setOpenAlertas(!openAlertas)}>
            {openAlertas ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Tooltip>
      </Grid>
      {openAlertas && alertas && alertas.map((alerta, index) => {
        return (
          <TipoAlertasCard
            key={index}
            index={index}
            alerta={alerta}
          />
        )
      })}
    </Grid>
  )
}

export default TipoAlertasCategoriaCard;